import { render, staticRenderFns } from "./FormHealth.vue?vue&type=template&id=91a67590"
import script from "./FormHealth.vue?vue&type=script&lang=ts"
export * from "./FormHealth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports